import { toast, type Toast } from "./toast"

// Apollo hands back a fresh Error instance per failed request, and the
// same reference across re-renders while the query stays in that errored
// state, so dedupe on identity rather than tracking prior renders.
const shownErrors = new WeakSet<object>()

export function errorToast(error: Error | undefined | null, props: Toast) {
  if (!error || shownErrors.has(error)) return
  shownErrors.add(error)
  toast({
    variant: "destructive",
    duration: 5000,
    ...props,
  })
}
